import { Link } from "react-router-dom";

const styles = {
  primary:
    "bg-ostelo-deep text-white hover:bg-ostelo-blue shadow-[0_8px_30px_rgb(23,63,95,0.18)]",
  accent:
    "bg-ostelo-orange text-ostelo-deep hover:bg-[#e88f26] shadow-[0_8px_30px_rgb(249,157,47,0.25)]",
  ghost:
    "border border-ostelo-deep/20 text-ostelo-deep hover:border-ostelo-deep/50 hover:bg-white",
  ghostLight:
    "border border-white/30 text-white hover:border-white/70 hover:bg-white/10",
};

export const Btn = ({ to, children, variant = "primary", className = "", testId, onClick }) => {
  const cls = `inline-flex items-center gap-2 rounded-lg px-6 py-3.5 text-sm font-semibold tracking-wide transition-[background-color,border-color,transform] duration-300 hover:scale-[0.98] active:scale-[0.96] ${styles[variant]} ${className}`;
  if (!to) {
    return (
      <button type="button" onClick={onClick} data-testid={testId} className={cls}>
        {children}
      </button>
    );
  }
  return (
    <Link to={to} onClick={onClick} data-testid={testId} className={cls}>
      {children}
    </Link>
  );
};
